import { render, staticRenderFns } from "./section-header.vue?vue&type=template&id=059fc0ff&scoped=true&"
import script from "./section-header.vue?vue&type=script&lang=js&"
export * from "./section-header.vue?vue&type=script&lang=js&"
import style0 from "./section-header.vue?vue&type=style&index=0&id=059fc0ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059fc0ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059fc0ff')) {
      api.createRecord('059fc0ff', component.options)
    } else {
      api.reload('059fc0ff', component.options)
    }
    module.hot.accept("./section-header.vue?vue&type=template&id=059fc0ff&scoped=true&", function () {
      api.rerender('059fc0ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/typography/section-header/section-header.vue"
export default component.exports